const toNumber = (v: any) => parseFloat(v) || 0;

// ---------- ROUND ----------
const round = (value: any) => {
    value = parseFloat(value);
    value = parseFloat(value.toFixed(4)); // Avoid floating point errors

    // Convert to upper 0.0x
    const isZero = value.toString()[0] === '0';
    if (isZero) value += 1;
    value = Math.ceil(value * 100) / 100;
    if (isZero) value -= 1;

    value = parseFloat(value.toFixed(2)); // Round to 2 decimals
    return value;
};

// ---------- LINE TOTAL HT ----------
export const getInvoiceLineTotalHT = (items: any[]) => {
    const totalHT = items.reduce((acc: number, item: any) => {
        const price = toNumber(item.price);
        const quantity = toNumber(item.quantity);
        const discountValue = toNumber(item.discountValue);

        let discount = 0;
        if (item.discountType === "percent")
            discount = price * quantity * (discountValue / 100);
        else if (item.discountType === "value")
            discount = discountValue;

        return acc + (price * quantity - discount);
    }, 0);

    return round(totalHT);
};

// ---------- TOTAL HT ----------
export const getTotalHT = (items: any) => {
    let totalHT = 0;
    for (const item of items) {
        totalHT += getInvoiceLineTotalHT([item]);
    }
    return round(totalHT);
};

// ---------- TOTAL TTC ----------
export const getTotalTTC = (items: any[]) => {
    const totalHT = getTotalHT(items);

    // Extract unique VAT rates
    const differentVatRates = items.reduce((acc: any[], item: any) => {
        const vat = toNumber(item.vat);
        if (!acc.includes(vat)) acc.push(vat);
        return acc;
    }, []);

    let totalVAT = 0;

    for (const vatRate of differentVatRates) {
        let vat = items.reduce((acc: number, item: any) => {
            const itemVAT = toNumber(item.vat);
            if (itemVAT !== vatRate) return acc;

            const lineHT = getInvoiceLineTotalHT([item]);
            return acc + lineHT * (itemVAT / 100);
        }, 0);

        totalVAT += round(vat);
    }

    return round(totalHT + totalVAT);
};

// ---------- TOTAL MARGIN ----------
export const getTotalMargin = (items: any) => {
    let totalPurchasePrice = items.reduce(
        (acc: number, item: any) =>
            acc + (toNumber(item.totalPurchasePrice) * toNumber(item.quantity) || 0),
        0
    );

    let totalSellPrice = getTotalHT(items);

    const itemWithoutTotalPurchasePrice = items.find(
        (item: any) =>
            (item.totalPurchasePrice === undefined ||
                item.totalPurchasePrice === null) &&
            !item._id?.includes("custom")
    );

    if (itemWithoutTotalPurchasePrice) return 0;
    if (!totalPurchasePrice) return 0;

    return totalSellPrice - totalPurchasePrice;
};

export { round };
